import { useTheme } from '@material-ui/core/styles';
import { DevHubTheme } from '@devxdiscover/devhub-ui';

/**
 * Custom sidebar icon for Nova (AI assistant) using an inline SVG sparkle/star design.
 * Uses the theme's purpleBlue gradient to match the DevHub palette.
 * Renders at 24x24 to match Material UI icon sizing used by other sidebar items.
 */
const NovaIcon = () => {
  const theme = useTheme<DevHubTheme>();
  const gradient = theme.palette.gradients.redPink;

  // Extract the two stop colors from the gradient string for SVG stops
  const colorMatch = gradient.match(/#[0-9a-fA-F]{6}/g);
  const stopStart = colorMatch?.[0] ?? '#6E55DC';
  const stopEnd = colorMatch?.[1] ?? '#069DE0';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={24}
      height={24}
      aria-label="Nova"
      style={{ display: 'block', overflow: 'visible' }}
    >
      <defs>
        <linearGradient id="nova-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={stopStart} />
          <stop offset="100%" stopColor={stopEnd} />
        </linearGradient>
      </defs>

      {/* Large central 4-point star */}
      <path
        d="M12 2 L13.2 9.8 L21 11 L13.2 12.2 L12 20 L10.8 12.2 L3 11 L10.8 9.8 Z"
        fill="url(#nova-gradient)"
      />

      {/* Small accent sparkle — top right */}
      <path
        d="M19 2 L19.6 5.4 L23 6 L19.6 6.6 L19 10 L18.4 6.6 L15 6 L18.4 5.4 Z"
        fill="url(#nova-gradient)"
        opacity="0.8"
      />

      {/* Tiny dot sparkle — bottom left */}
      <circle cx="5" cy="18" r="1.2" fill="url(#nova-gradient)" opacity="0.6" />
    </svg>
  );
};

export default NovaIcon;
